import { accordionFactoryModule } from './accordion/di';
import { admonitionFactoryModule } from './admonition/di';
import { blockFileFactoryModule } from './block-file/di';
import { clickImageFactoryModule } from './click-image/di';
import { flipcardFactoryModule } from './flipcard/di';
import { galleryFactoryModule } from './gallery/di';
import { hotspotFactoryModule } from './hotspot/di';
import { embedFactoryModule } from './embed/di';
import { tabsFactoryModule } from './tabs/di';
import { tableFactoryModule } from './table/di'
import { questionFactoryModule } from './question/di'
import { quizFactoryModule } from './quiz/di';
import { codeFactoryModule } from './code/di'

export const interactionPluginModules = [
  accordionFactoryModule,
  admonitionFactoryModule,
  blockFileFactoryModule,
  clickImageFactoryModule,
  flipcardFactoryModule,
  galleryFactoryModule,
  hotspotFactoryModule,
  embedFactoryModule,
  tabsFactoryModule,
  tableFactoryModule,
  questionFactoryModule,
  quizFactoryModule,
  codeFactoryModule
]
